module.exports = __webpack_public_path__ + "static/media/logo01.84a1dc35.png";